module.exports = __webpack_public_path__ + "static/media/baseMeme1thumb.9ad9be39.jpg";